import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { OrganizationService } from 'src/app/services/organization.service';
import { Lookup } from 'src/app/model/lookup';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { ZoneService } from 'src/app/services/zone.service';

@Component({
  selector: "app-zone-add-dialog",
  templateUrl: "./zone-add-dialog.component.html",
  styleUrls: ["./zone-add-dialog.component.scss"]
})
export class ZoneAddDialogComponent implements OnInit {
  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean = true;
  public currentValue: any;

  constructor(public dialogRef: MatDialogRef<ZoneAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public zoneService: ZoneService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

  ngOnInit() {
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
    this.initlizeUserAddForm();
  }

  showField(){
    document.getElementById('hiddenField').className = "d-block";
  }

  hideField(){
    document.getElementById('hiddenField').className = "d-none";
  }

  showhideField(){
    let fielddata = this.form.getRawValue();
    if(fielddata.parkingType == "1"){
      this.showField();
    }
    if(fielddata.parkingType == "2"){
      this.hideField();
    }
  }

  initlizeUserAddForm(): void {
    this.form = new FormGroup({
      zoneId: new FormControl("", Validators.required),
      zoneName: new FormControl("", Validators.required),
      parkingType: new FormControl("", Validators.required),
      description: new FormControl("Flowbird", Validators.required),
      duration: new FormControl("0"),
      gracePeriod: new FormControl("0"),
      multipleTicket: new FormControl("false"),
      // status: new FormControl(this.isStatus, Validators.required)
    });
  }

  addZoneData(): void {
    let data = this.form.getRawValue();
    if(data.parkingType == 2){
      data.description = 'Permitted';
    }
    //data.organizationId = this.tokenStorage.getOrganizationId();
    // data.status = this.isStatus ? 1 : 3;
    data.organizationId = this.orgId;

    this.zoneService.addZone(data)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        if(response.data.id == null){
          this.toastrService.error("Zone Already Exist");
        }
        else{
          this.toastrService.success(response.value, "Zone Added Successfully!");
          this.dialogRef.close(true);
        }
      } else {
        this.toastrService.error(response.value, "Failed To Load Data!")
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}